import React from 'react';
import { FormProvider } from 'react-hook-form';
import { validation } from './AccountInfo.meta';
import { DraftAccountDTO, FORM_WIDTH } from '../../AccountOpening.meta';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { ControlPerson } from '../../fields/ControlPerson/ControlPerson';
import { Footer } from '../../components/Footer/Footer';
import { AffiliatedExchange } from '../../fields/AffiliatedExchange/AffiliatedExchange';
import { PoliticallyExposed } from '../../fields/PoliticallyExposed/PoliticallyExposed';
import { LiquidityNeeds } from '../../fields/LiquidityNeeds/LiquidityNeeds';
import { TimeHorizon } from '../../fields/TimeHorizon/TimeHorizon';
import { RiskTolerance } from '../../fields/RiskTolerance/RiskTolerance';
import { InvestmentExperience } from '../../fields/InvestmentExperience/InvestmentExperience';
import { InvestmentObjective } from '../../fields/InvestmentObjective/InvestmentObjective';
import { TrustedContact } from '../../fields/TrustedContact/TrustedContact';
import { InterestedParty } from '../../fields/InterestedParty/InterestedParty';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import { useStepForm } from '../../hooks/useStepForm';
import { StepContent } from '../../components/StepContent/StepContent';
import { StepCard } from '../../components/StepCard/StepCard';
import { CustodianEmployee } from '../../fields/CustodianEmployee/CustodianEmployee';

interface Props {
  draftAccount: DraftAccountDTO;
  onSuccess(): void;
  onPrevious?(): void;
}

export const AccountInfo: React.FC<Props> = ({ draftAccount, onSuccess, onPrevious }) => {
  const { formBag, saveDraftMutation, onSubmit } = useStepForm({
    draftAccount,
    onSuccess,
    validation,
  });

  return (
    <FormProvider {...formBag}>
      <form onSubmit={formBag.handleSubmit(onSubmit)}>
        <StepContent>
          <StepCard maxWidth={FORM_WIDTH}>
            <Text as="h2" fontSize="h5" fontWeight={600}>
              Account Information
            </Text>

            {saveDraftMutation.error && (
              <Alert message={saveDraftMutation.error.message} variant="error" mt="32" />
            )}

            <ControlPerson draftAccount={draftAccount} mt="32" />

            <CustodianEmployee draftAccount={draftAccount} mt="32" />

            <AffiliatedExchange draftAccount={draftAccount} mt="32" />

            <PoliticallyExposed mt="32" />

            <LiquidityNeeds mt="32" />

            <TimeHorizon mt="32" />

            <RiskTolerance mt="32" />

            <InvestmentExperience mt="32" />

            <InvestmentObjective mt="32" />

            <TrustedContact mt="32" />

            <InterestedParty mt="32" />
          </StepCard>
        </StepContent>

        <Footer isLoading={saveDraftMutation.isLoading} onPrevious={onPrevious} />
      </form>
    </FormProvider>
  );
};
